export const SET_IS_LOGGED_In = "SET_IS_LOGGED_In"
export const SET_USER = "SET_USER"
export const SET_TOKEN = "SET_TOKEN"
export const SET_LOADER = "SET_LOADER"
export const SET_COURSE_DATA = "SET_COURSE_DATA"
export const SET_TEMP_SUBCATEGORY_DATA = "SET_TEMP_SUBCATEGORY_DATA"
